import { Pipe, PipeTransform } from '@angular/core';
import { ISbRichtext, renderRichText } from '@storyblok/js';

@Pipe({
  name: 'storyblokRichText',
  standalone: true,
})
export class StoryblokRichTextPipe implements PipeTransform {
  transform(value: ISbRichtext | string): string {
    if (!value) return '';
    if (typeof value === 'string') return value;
    const html = renderRichText(value);
    return html.replace(/<li><p>/g, '<li>').replace(/<\/p><\/li>/g, '</li>');
  }
}
